import React from 'react';
import { render } from 'react-dom';
import App from './app';

render( <div><App/></div>, document.querySelector("#app"));

